'use client';
import React from 'react';

import type { Currency } from '@/constants/currency/currency';
import HorizontalProductCard from './HorizontalProductCard';
import VerticalProductCard from './VerticalProductCard';
import { Condition } from '@/utils/react';
import ProductCardSkeleton from './ProductCard.Skeleton';

export type ProductCardProps = {
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  name: string;
  brand: string;
  productImage: string;
  sku: string;
  currency: Currency;
  showRating?: boolean;
  rating?: number;
  showRanking?: boolean;
  ranking?: number;
  reviewCount?: number;
  originalPrice: number;
  salePrice?: number;
  orientation?: 'vertical' | 'horizontal';
};

const ProductCard = ({
  showRating = false,
  showRanking = true,
  orientation = 'vertical',
  ...props
}: ProductCardProps) => {
  const componentProps = { ...props, showRating, showRanking };
  return (
    <Condition
      expression={orientation === 'vertical'}
      then={<VerticalProductCard {...componentProps} />}
      else={<HorizontalProductCard {...componentProps} />}
    />
  );
};

ProductCard.Skeleton = ProductCardSkeleton;

export default ProductCard;
